import clsx from 'clsx'
import React, { ReactNode } from 'react'
import { Text, TextProps } from '../Typography'
import { TIMELINE_TEXT_DISPLAY_NAME } from './constants'
import styles from './style.module.scss'

export interface TimelineTextProps extends TextProps {
  children: ReactNode
  isVertical?: boolean
  testNameSpace?: string
}

export const TimelineText = React.forwardRef<HTMLDivElement, TimelineTextProps>(
  ({ children, isVertical = false, testNameSpace = 'timeline-text', ...others }, ref): JSX.Element => {
    const cls = clsx(isVertical ? styles.timelineTextV : styles.timelineText)

    return (
      <div className={cls} data-testid={testNameSpace}>
        <Text renderAs='div' {...others}>
          {children}
        </Text>
      </div>
    )
  }
)

TimelineText.displayName = TIMELINE_TEXT_DISPLAY_NAME
